import React, { useEffect } from "react";

const Countersection = () => {
  useEffect(() => {
    const counters = document.querySelectorAll(".counter");
    const speed = 500;

    const resetCounters = () => {
      counters.forEach((counter) => (counter.innerText = "0"));
    };

    const animateCounters = () => {
      counters.forEach((counter) => {
        const updateCount = () => {
          const target = +counter.getAttribute("data-target");
          const count = +counter.innerText;

          const increment = target / speed;

          if (count < target) {
            counter.innerText = Math.ceil(count + increment);
            setTimeout(updateCount, 1);
          } else {
            counter.innerText = target;
          }
        };

        updateCount();
      });
    };

    const section = document.querySelector(".outer_counter_section");
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          resetCounters();
          animateCounters();
        }
      },
      { threshold: 0.5 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="outer_counter_section">
      {/* <div className="counter_section">
        <div
          id="carouselExampleControls"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div
              className="carousel-item active"
              style={{ overflow: "hidden", maxHeight: "500px" }}
            >
              <img
                src="/assets/images/new_images/banners/2.jpg"
                className="d-block w-100"
                alt="home banner1"
                style={{ objectFit: "cover" }}
              />
            </div>
            <div className="carousel-item">
              <img
                src="/assets/images/new_images/banners/1.jpg"
                className="d-block w-100"
                alt="home banner2"
              />
            </div>
            <div className="carousel-item">
              <img
                src="/assets/images/new_images/banners/4.jpg"
                className="d-block w-100"
                alt="home banner3"
              />
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <div className="counter_section_images_overlay">
          <div className="counter_section_images_inneroverlay"></div>
        </div>
      </div> */}
      <div className="counter_container shadow">
        <div className="counter_innercontainer">
          <div className="counters">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3 className="counter" data-target="1500">
                0
              </h3>
              <h3>+</h3>
            </div>
            <h6 style={{ color: "#c82e21" }}>Happy Clients</h6>
          </div>
          <div className="counters">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3 className="counter" data-target="25">
                0
              </h3>
              <h3>+</h3>
            </div>
            <h6 style={{ color: "#c82e21" }}>Years</h6>
          </div>
          <div className="counters">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3 className="counter" data-target="386">
                0
              </h3>
              <h3>+</h3>
            </div>
            <h6 style={{ color: "#c82e21" }}>Projects</h6>
          </div>
          <div className="counters">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h3 className="counter" data-target="99">
                0
              </h3>
              <h3>%</h3>
            </div>
            <h6 style={{ color: "#c82e21" }}>Quality</h6>
          </div>
        </div>
      </div>
    </section>
  );
};

export { Countersection };
